<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm" class="components">
      <el-row>
        <el-col>
          <el-col :span="6">
            <el-form-item label="의뢰번호" prop="catNm">
              <el-input v-model="form.requestId" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="의뢰일자">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestDt" style="width: 100%;" value-format="yyyy-MM-dd" ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="의뢰자" prop="catNm">
              <el-input v-model="form.requestNm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="의뢰구분">
              <el-select v-model="form.maType">
                <el-option value=''  label="선택">선택</el-option>
                <el-option
                    v-for="item in combos['maType']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="고객구분">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.siteTypeNm" style="width: 70%" readonly></el-input>
                <el-button type="primary" icon="el-icon-search" @click="searchSite"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="사이트명">
              <el-row>
                <el-col :span="24">
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm1" disabled></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm2" disabled></el-input>
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="form.siteNm3" disabled></el-input>
                  </el-col>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="주소">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.zipCd" disabled style="width: 70%"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="　">
              <el-input v-model="form.addr1" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="　">
              <el-input v-model="form.addr2" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="8">
            <el-form-item label="고객명">
              <el-input v-model="form.chargeNm" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="전화번호">
              <el-input v-model="form.telNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="휴대폰">
              <el-input v-model="form.hpNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="4">
            <el-form-item label="모델">
              <div style="display: flex; width: 100%">
                <el-input v-model="form.modelNm" style="width: 70%"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="searchModel"/>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="의뢰대수" prop="catNm">
              <el-input v-model="form.modelQty"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="처리내역">
              <el-radio-group v-model="form.procType">
                <el-radio
                    v-for="item in combos['procType']"
                    :key="item.key"
                    :label="item.key"
                    :value="item.key">{{ item.value }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="6">
            <el-form-item label="처리요청일">
              <el-date-picker type="date" placeholder="Pick a date" v-model="form.requestProcDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="지역/센터">
              <el-select v-model="form.catId" placeholder="지역/센터" @change="onCatIdChange">
                <el-option
                    v-for="item in combos['catId']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="지역/센터 상세">
              <el-select v-model="form.asAgentId" placeholder="지역/센터 상세" @change="getSubCatIdChange">
                <el-option
                    v-for="item in combos['asAgentId']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="처리기사">
              <el-select v-model="form.userId">
                <el-option
                    v-for="item in combos['userId']"
                    :key="item.key"
                    :value="item.key"
                    :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

      <el-row class="demo-autocomplete" >
        <el-col :span="24">
          <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5}"
              placeholder="작업내용을 작성하세요."
              v-model="form.workDetails">
          </el-input>
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>

      <el-row class="demo-autocomplete" >
        <el-col :span="24">
          <el-input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5}"
              placeholder="특기사항을 작성하세요."
              v-model="form.memo">
          </el-input>
          <div class="grid-content bg-purple"></div>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <el-col :span="6">
            <el-form-item label="처리비">
              <el-input v-model="form.procUnitPrice1" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="단가">
              <el-input v-model="form.procUnitPrice2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="출장급지" prop="catNm">
              <el-input v-model="form.procEtcPrice1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="기타비용" prop="catNm">
              <el-input v-model="form.procEtcPrice2"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>
    </el-form>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="table-name">
            <h3 class="ico_table_name">{{ `사용/회수자재` }}</h3>
          </div>
          <div class="btn-wrap btn-type1 clearfix">
            <button class="btn-size btn-gray fl_left" @click="openModel">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
              추가
            </button>
            <button class="btn-size btn-gray fl_left" @click="cancle">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
              취소
            </button>
            <button class="btn-size btn-gray fl_left" @click="deleteItem" v-if="form.requestId != ''">
                        <span class="btn-icon">
                            <i class="fas fa-save"></i>
                        </span>
              삭제
            </button>
          </div>
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @cell-value-changed="onCellValueChanged"
                @grid-ready="onReadyMain"/>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import SelectCellRendererSecondary from "@/components/agGrid/select-cell-renderer-secondary";
import mixin from "@/mixin/lucoms";
import ModelSelectModal from "@/components/AS/NormalConsult/Modal/ModelSelectModal";
import SiteSelectModal from "@/components/LucomsModal/SiteSelectModal";
import UseMateSelectModal from "@/components/LucomsModal/UseMateSelectModal";
import ReqMateEnterModal from "@/components/LucomsModal/ReqMateEnterModal";
import AgGridSearchBtn from "@/components/agGrid/AgGridSearchBtn";
import _ from "lodash";

function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default {
  name: "bsMaEditInfo",
  mixins: [mixin],
  props: ['bsMaEditDetail'],
  data() {
    return {
      data: [],
      delData: [],
      gridStyle : 'padding-top: 40px; width: 100%;height: 200px; min-height:100px;',
      columnDefs: [],
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        schBtn : AgGridSearchBtn,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer,
        secondarySelect: SelectCellRendererSecondary,
      },
      form: {
        companyId : '',
        requestId : '',          // 의뢰번호
        requestDt : '',          // 의뢰일자
        requestNm : this.$store.state.loginInfo.userName,          // 의뢰자
        maType : 'BS',           // 의뢰구분
        siteType : '',           // 고객구분
        siteTypeNm : '',         // 고객구분
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        modelNm : '',            // 모델명
        modelQty : '',           // 의뢰대수
        procType : 'Check',      // 처리내역
        requestProcDt : '',      // 처리요청일
        workDetails : '',        // 작업내용
        memo : '',               // 특기사항
        procUnitPrice1 : '',     // 처리비
        procUnitPrice2 : '',     // 단가
        procEtcPrice1 : '',      // 출장급지
        procEtcPrice2 : '',      // 기타비용
        catId : '',              // 지역
        asAgentId: '',            // 지역상세
        sortType : '',           // 승인/정산처리유형
        siteId : '',             // 사이트Id
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        userId : '',             // 처리기사
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelGroup: '',          /** 모델그룹 */
        standardModelNm: '',     /** 표준모델 */
        //modelNm: '',           /** 모델명 */
        modelId: '',             /** 모델ID */
        siteTypeCombo : '',

        applyItemGoodQty : '',
        recallItemQty : '',
      },
      defForm: {
        companyId : '',
        requestId : '',          // 의뢰번호
        requestDt : '',          // 의뢰일자
        requestNm : this.$store.state.loginInfo.userName,          // 의뢰자
        maType : 'BS',           // 의뢰구분
        siteType : '',           // 고객구분
        siteTypeNm : '',         // 고객구분
        addr1 : '',              // 주소1
        addr2 : '',              // 주소2
        chargeNm : '',           // 고객명
        telNo : '',              // 전화번호
        hpNo : '',               // 휴대폰
        modelNm : '',            // 모델명
        modelQty : '',           // 의뢰대수
        procType : 'Check',      // 처리내역
        requestProcDt : '',      // 처리요청일
        workDetails : '',        // 작업내용
        memo : '',               // 특기사항
        procUnitPrice1 : '',     // 처리비
        procUnitPrice2 : '',     // 단가
        procEtcPrice1 : '',      // 출장급지
        procEtcPrice2 : '',      // 기타비용
        catId : '',              // 지역
        asAgentId: '',            // 지역상세
        sortType : '',           // 승인/정산처리유형
        siteId : '',             // 사이트Id
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        userId : '',             // 처리기사
        maker: '',               /** 제조사 */
        makerNm: '',             /** 제조사명 */
        modelGroupNm: '',        /** 모델그룹명 */
        modelGroup: '',          /** 모델그룹 */
        standardModelNm: '',     /** 표준모델 */
        //modelNm: '',           /** 모델명 */
        modelId: '',             /** 모델ID */
        siteTypeCombo : '',

        applyItemGoodQty : '',
        recallItemQty : '',
      },
      // eslint-disable-next-line vue/no-dupe-keys
      tapName: "default",
      combos: {
        'maType' : [],
        'catId' : [],
        'asAgentId' : [],
        'procType' : [],
        'userId' : [],
      },
    };
  },
  methods: {
    setBsMaEditInfo() {
      // Object.assign(this.form, this.bsMaEditDetail.uvwBsMaItemM[0]);
      //Object.assign(this.form, this.bsMaEditDetail.uvwBsMaItemD);
      this.form = this.bsMaEditDetail.uvwBsMaItemM[0]
      this.data = this.bsMaEditDetail.uvwBsMaItemD
      // 처리기사, 지역센터 값 세팅
      this.getAgentId(this.form.asAgentId);
      this.changeData();
    },
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;
      //this.getGuaranteeMonth();
      this.init();
    },
    async init() {
      this.form.requestDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      this.form.requestProcDt = this.$moment().format('YYYY-MM-DD') /** 당일 */
      //this.$store.commit('loading');
      // await this.$http.post(`/api/workMng/bsMaEdit/init`)
      //     .then(response => {
      //       this.combos['maType'] = response.data.maType;
      //       this.combos['catId'] = response.data.catId;
      //       this.combos['siteType'] = response.data.siteType;
      //     }).finally(() => {
      //       //this.goOpen();
      //       this.$store.commit('finish');
      //     });
      this.createMainColumnDefs();
    },
    createMainColumnDefs() {
      const vm = this;
      this.columnDefs = [
        {
          headerName:'선택',
          field:'chk',
          width:80,
          cellStyle:{textAlign: 'center'},
          cellRenderer: 'checkBox',
          ellRendererParams: {
              trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: true
          },
        },
        {
          headerName:'No',
          field:'순위',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'사용품번', field:'applyItemCd', width:200},
        {headerName:'사용품명', field:'applyItemNm', width:350},
        {headerName:'사용수량', field:'applyItemGoodQty', width:120, cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'}, editable : true,
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }
        },
        {headerName:'회수', field:'', width:100,
          cellRenderer: 'schBtn',
          cellRendererParams:{
            funcNm : 'updateRealItem',
          } },
        {headerName:'회수품번', field:'applyRecallItemCd', width:200},
        {headerName:'회수품명', field:'applyRecallItemNm', width:350},
        {headerName:'회수수량', field:'applyRecallItemQty', width:120, cellStyle:{textAlign: 'right'},
          valueFormatter: (params) => {
            return vm.getNumberFormat(params.value);
          }
        },
      ];
    },
    deleteButton(){
    },
    saveButton(){
    },
    goOpen(){
    },
    /**
     * 사용 회수 자재 팝업 오픈
     * *
     */
    openModel() {
      let vm = this;
      this.$modal.open({
        width: 1500,
        component: UseMateSelectModal,
        parent: this,
        props: {
          data: {
            modelNm : vm.form.modelNm
          }
        },
        events: {
          close(param) {

            let allItemIds = '' // 기존의 품목ID들
            if(vm.data != '') {
              vm.data.map(x => {
                allItemIds += x.itemCd + ','
                return x
              })
            }

            //이미 추가한 품목은 제외시킴
            let vvRetData2 = (allItemIds === '') ? param : ( param.filter(x=>allItemIds.indexOf(x.itemCd + ',') == -1) )
            const vData = vvRetData2

            //
            // const vSumArr = vm.data.concat(vData)
            // vm.data = vSumArr

            vData.forEach(x=>{
              vm.data.push({
                  itemId : x.itemId,
                  goodQty : 0,
                  applyItemCd : x.itemCd,
                  applyItemNm : x.itemNm,
                  applyItemGoodQty : 0,
                  applyRecallItemCd : x.itemCd,
                  applyRecallItemNm : x.itemNm,
                  applyRecallItemQty : x.goodQty,
              })
            });

            // vm.data.map((x=> {
            //   x.goodQty = 1
            //   x.applyItemCd = x.itemCd
            //   x.applyItemNm = x.itemNm
            //   x.applyItemGoodQty = x.goodQty
            //   x.applyRecallItemCd = x.itemCd
            //   x.applyRecallItemNm = x.itemNm
            //   x.applyRecallItemQty = x.goodQty
            // }));

          },
        }
      });
    },
    cancle(){
        // this.form = _.clone(this.defForm);
        this.data = [];
    },
    deleteItem() {

      var list = this.data.filter(v => v.chk === 'Y')

      if(list.length == 0){
        this.$swal({ type: 'warning', text: '삭제할 자재를 선택해 주십시요.'});
        return false;
      }

      const vm = this
      const vData = vm.data.filter(v => v.chk !== 'Y')
      this.delData = vm.data.filter(v => v.chk === 'Y')

      vm.data = JSON.parse(JSON.stringify(vData))

    },
    getCombo() {
      this.getMaType();
      this.getCatIdCombo();
      this.getProcType();
    },
    getMaType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 226} })
          .then(response => {
            this.combos['maType'] = response.data || []
          });
    },
    getProcType(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 247} })
          .then(response => {
            this.combos['procType'] = response.data || []
          });
    },
    getCatIdCombo(){
      this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
          .then(response => {
            this.combos['catId'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.asAgentId = null;
      this.form.userId = null;
      // 지역 상세
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: param} })
          .then(response => {
            this.combos['asAgentId'] = response.data || []
          }).finally(() => {
      });
    },
    getSubCatIdChange(param){
      this.$store.commit('loading')
      this.form.userId = null;


      this.$http.post("/api/asAgentMng/detail/agent", {
        companyId: this.$store.state.loginInfo.compCd,
        asAgentId: parseInt(param),
        userId : 0,
        useYn : 'Y',
        processTime: ""
      }).then(response => {
        response.data.map(x => {
          x.key = x.userId
          x.value = x.userNm
          return x
        })
        this.combos['userId'] = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    // 그리드 데이터 선택 후 처리기사 값 세팅
    getAgentId(param){
      //this.form.userId = '';
      this.$http.post("/api/asAgentMng/detail/agent", {
            companyId: this.$store.state.loginInfo.compCd,
            asAgentId: param,
            userId : 0,
            useYn : 'Y',
            processTime: ""
      }).then(response => {
        this.combos['userId'] = response.data.map(x => {
          x.key = x.userId
          x.value = x.userNm
          return x
        });
        // 그리드에서 선택한 배송기사 값
        let asAgentUserId = (this.form.userId !== undefined) ? this.form.userId.toString() : ''
        if(asAgentUserId !== ''){
          let valueUserId = this.combos['userId'].filter(x => x.key === asAgentUserId)[0].key;
          this.form.userId = _.cloneDeep(valueUserId);
        }
      }).finally(() => {
        this.setCatIdAndSubCatId(param);
      })
    },
    //  그리드 데이터 선택 후 지역/센터 값 세팅
    setCatIdAndSubCatId(param){
      let valueSubCatId;
      this.$http.get(`/api/codeMng/detail`, { params: {catKey: param}})
        .then(response => {
          // 조회 한 지역/센터 값
          valueSubCatId = response.data;
          // 지역 값 선택
          this.form.catId  = _.cloneDeep(this.combos['catId'].filter(x => parseInt(x.key) === valueSubCatId[0].parentId)[0].key)
          // 지역 상세값 리스트 조회
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: valueSubCatId[0].parentId} }).then(response => {
              this.combos['asAgentId'] = response.data || []
              // 지역 상세값 선택
              this.form.asAgentId  = _.cloneDeep(this.combos['asAgentId'].filter(x => x.key === valueSubCatId[0].catKey)[0].key)
            })
        })
    },
    dataClear(){
       this.form.companyId = ''
       this.form.requestId = ''          // 의뢰번호
       this.form.requestDt = ''          // 의뢰일자
       this.form.requestNm = ''          // 의뢰자
       this.form.maType = ''             // 의뢰구분
       this.form.siteType = ''           // 고객구분
       this.form.siteTypeNm = ''         // 고객구분명
       this.form.addr1 = ''              // 주소1
       this.form.addr2 = ''              // 주소2
       this.form.chargeNm = ''           // 고객명
       this.form.telNo = ''              // 전화번호
       this.form.hpNo = ''               // 휴대폰
       this.form.modelNm = ''            // 모델
       this.form.modelQty = ''           // 의뢰대수
       this.form.requestProcDt = ''      // 처리요청일
       this.form.workDetails = ''        // 작업내용
       this.form.memo = ''               // 특기사항
       this.form.procUnitPrice1 = ''     // 처리비
       this.form.procUnitPrice2 = ''     // 단가
       this.form.procEtcPrice1 = ''      // 출장급지
       this.form.procEtcPrice2 = ''      // 기타비용
       this.form.catId = ''              // 지역
       this.form.asAgentId = ''          // 지역상세
       this.form.sortType = ''           // 승인/정산처리유형
       this.form.siteNm1 = ''            // 사이트명1
       this.form.siteNm2 = ''            // 사이트명2
       this.form.siteNm3 = ''            // 사이트명3
       this.form.userId = ''             // 처리기사
       this.data = '';
    },
    searchModel(){
      /** 모델선택 */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ModelSelectModal,
        parent: this,
        props: {
          data: {
          },
        },
        events: {
          close(param) {
            vm.form.maker = param.data.maker /** 제조사 */
            vm.form.makerNm = param.data.makerNm /** 제조사명 */
            vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
            vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
            vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
            vm.form.modelNm = param.data.modelNm /** 모델명 */
            vm.form.modelId = param.data.modelId /** 모델ID */
          },
        }
      });
    },
    searchSite(){
      /** 사이트선택(고객구분) */
      let vm = this;
      this.$modal.open({
        width: 800,
        component: SiteSelectModal,
        parent: this,
        props: {
          data: {
          },
        },
        events: {
          close(param) {
            vm.form.siteNm1 = param.data.siteNm1          // 사이트명1
            vm.form.siteNm2 = param.data.siteNm2          // 사이트명2
            vm.form.siteNm3 = param.data.siteNm3          // 사이트명3
            vm.form.addr1 = param.data.addr1              // 주소1
            vm.form.addr2 = param.data.addr2              // 주소2
            vm.form.chargeNm = param.data.chargeNm        // 고객명
            vm.form.telNo = param.data.telNo              // 전화번호
            vm.form.hpNo = param.data.hpNo                // 핸드폰
            vm.form.siteId = param.data.siteId            // 사이트Id
            vm.form.siteType = param.data.siteType        // 고객구분
            vm.form.siteTypeNm = param.data.siteTypeNm    // 고객구분
            vm.form.zipCd = param.data.zipCd              // 주소
            vm.getAgentId(param.data.asAgentId)           // 지역/센터, 처리시가 세팅
          },
        }
      });
    },
    changeData(){
      //고객구분 코드 => 코드명 변경
      let filterSiteType = this.form.siteTypeCombo.filter(x => x.key === this.form.siteType);
      this.form.siteTypeNm = filterSiteType[0].value;

      this.form.procUnitPrice1 = comma(this.form.procUnitPrice1);  // 처리비
      this.form.procUnitPrice2 = comma(this.form.procUnitPrice2);  // 단가
      this.form.procEtcPrice1 = comma(this.form.procEtcPrice1);    // 출장급지
      this.form.procEtcPrice2 = comma(this.form.procEtcPrice2);    // 기타비용
    },
    updateRealItem(pVal){

      const that = this;
      const rowNode = this.mainGridOptions.api.getRowNode(this.rowId);

      this.$modal.open({
        component: ReqMateEnterModal,
        parent: this,
        width: 700,
        props: {
          data: {
            modelNm : that.form.modelNm
          }
        },
        events: {
          close(object) {
            console.log("object" , object)
            rowNode.setDataValue('applyRecallItemCd', object.itemCd);
            rowNode.setDataValue('applyRecallItemNm', object.itemNm);
            that.data[that.rowId].applyRecallItemCd = object.itemCd;
            that.data[that.rowId].applyRecallItemNm = object.itemNm;
          }
        }
      });
    },
    onCellValueChanged(params) {

      if (params.colDef.field === "applyItemGoodQty") {
        // a 컬럼이 변경되었을 때만 처리
        const newValue = params.newValue;
        const rowIndex = params.rowIndex;
        const newData = this.data[rowIndex];
        newData.applyRecallItemQty = newValue       // 회수수량의 값을 사용수량 값으로 변경
        this.$set(this.data, rowIndex, newData);    // 변경된 데이터를 반영
      }
    }
  },
  mounted() {
    this.getCombo()
//    this.getConfigValue()
  },
  watch: {
    bsMaEditDetail() {
      this.setBsMaEditInfo();
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}
.el-select {
  width: 100%;
}
</style>



